import type { SVGProps } from 'react';

const EmptyBoxImage = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={234}
    height={160}
    fill='none'
    {...props}>
    <path
      fill='#fff'
      d='m150.729 109.543 7.586 9.383H91.283l-7.573-9.385 67.019.002Z'
    />
    <path
      fill='#fff'
      d='m150.729 109.543 22.237-9.065v-66.07L150.29 43.56H83.71l-22.676-9.154v66.074l22.676 9.063h67.019Z'
    />
    <path
      fill='#73DC78'
      fillRule='evenodd'
      d='M111.246 108.701h11.942l9.363 11.07h-11.942l-9.363-11.07Zm3.635 1.684 6.514 7.701h7.521l-6.514-7.701h-7.521Z'
      clipRule='evenodd'
    />
    <path fill='#DFE2E7' d='M150.731 52.883H92.609v56.661h58.122V52.883Z' />
    <path
      fill='#DFE2E7'
      d='M158.869 106.225v12.701h-.554l-7.586-9.383 8.14-3.318Z'
    />
    <path
      fill='#00004B'
      fillRule='evenodd'
      d='m60.19 33.156 23.684 9.561h66.251l23.685-9.559v67.885l-14.097 5.747v12.978H90.879l-7.686-9.525-23.003-9.194V33.156Zm25.285 77.229 6.213 7.699h64.862l-6.225-7.699h-64.85Zm66.624-.491 5.925 7.329v-9.744l-5.925 2.415Zm-2.212-1.193V53.724H93.454v54.975l56.433.002Zm-58.122-.002v-55.48l-7.21-7.553v63.032l7.21.001Zm-8.9-64.572v64.171L61.88 99.91V35.655l20.986 8.472Zm2.815.275 7.292 7.637h56.915v-7.637H85.68Zm65.896-.453v64.339l20.545-8.376V35.657l-20.545 8.292Z'
      clipRule='evenodd'
    />
  </svg>
);

export default EmptyBoxImage;
